import { isDataField } from '@eastcoal/formily/exports/core'
import {
  connect,
  mapProps,
  mapReadPretty
} from '@eastcoal/formily/exports/react'

import { OcrIdCard as LocalOcrIdCard } from '../../components/OcrIdCard'

export const OcrIdCard = {
  Front: connect(
    LocalOcrIdCard.Front,
    mapReadPretty(LocalOcrIdCard.Front, {
      disabled: true
    }),
    mapProps((props, field) => {
      return {
        ...props,
        onOcrError(error) {
          if (isDataField(field)) {
            field.selfErrors = [error.message]
          }
        }
      }
    })
  ),

  Back: connect(
    LocalOcrIdCard.Back,
    mapReadPretty(LocalOcrIdCard.Back, {
      disabled: true
    }),
    mapProps((props, field) => {
      return {
        ...props,
        onOcrError(error) {
          if (isDataField(field)) {
            field.selfErrors = [error.message]
          }
        }
      }
    })
  )
}
